import * as types from '../actionTypes/user'

let defaultState = {
  users: [],
  currentUser: {}
}

const userReducer = (state = defaultState, action) => {
  if (action.type === types.GET_USER) {
    // if view model not loaded then create empty object so we can bind form in components to that without undefined issues
    if (!action.user) {
      action.user = {}
    }
    return {
      ...state,
      currentUser: action.user
    }
  }
  else if (action.type === types.GET_USERS) {
    return {
      ...state,
      users: action.users
    }
  }
  else if (action.type === types.UPDATE_USER) {
    return {
      ...state,
      users: state.users.map(user => {
        return user.UserId === action.user.UserId ?
          {
            ...action.user
          } :
          {
            ...user
          }
      })
    }
  }
  else if (action.type === types.ADD_USER) {
    return {
      ...state,
      users: state.users.concat({
        ...action.user
      })
    }
  }
  else if (action.type === types.CLEAR_USER) {
    return {
      ...state,
      currentUser: {}
    }
  }
  else {
    return {
      ...state
    }
  }
}

export default userReducer;


// WEBPACK FOOTER //
// ./src/reducers/user.js